module.exports = __webpack_public_path__ + "assets/ce46546209f04a0d82b581190312103f.png";